'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentCardVideo = require('./ContentCardVideo');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentCardVideo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }